module.exports = __webpack_public_path__ + "brandon_thin-webfont.bcef4d0e37030421295a.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brandon_thin-webfont.woff2
// module id = 952
// module chunks = 7